import PivotRepository from "@/services/resources/pivot-repository";
import byNewsItem from "@/services/resources/mixins/query-by-news-item";
import byPerson from "@/services/resources/mixins/query-by-person";

class Repository extends PivotRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byNewsItem).$mix(byPerson);
    }

    newsItemsByPerson(id) {
        return this.relation('newsItems', 'personId', id, null, [], 'newsItems');
    }

    peopleByNewsItem(id) {
        return this.relation('people', 'newsItemId', id, null, [], 'people');
    }
}

export default Repository;
